import { render, staticRenderFns } from "./piPackageManagement.vue?vue&type=template&id=2ddc1a80&scoped=true"
import script from "./piPackageManagement.vue?vue&type=script&lang=ts"
export * from "./piPackageManagement.vue?vue&type=script&lang=ts"
import style0 from "./piPackageManagement.vue?vue&type=style&index=0&id=2ddc1a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc1a80",
  null
  
)

export default component.exports